import moment from 'moment';

export const Saluation = [
  { value: 'plot', label: 'Plot' },
  { value: 'bunglow', label: 'Bunglow' }
];

export default [
  {
    id: 1,
    createdAt: moment().add(12, 'M'),
    firstName: 'Dhaivat',
    lastName: 'Khanpara',
    middleName: 'Jitendrakumar',
    email: 'dhaivat.khanpara@gmail.com',
    address: 'L 105, Malabar county',
    address2: 'Behind nirma university',
    state: 'gujarat',
    zip: '380015',
    phone: '9408409406',
    cellPhone: '079 22222222',
    notes: 'Dhaivat interested in 2BHK',
    city: 'Ahmedabad',
    title: 'Lead 1',
    company: 'Delby Developers inc',
    saluation: Saluation[0]
  },
  {
    id: 2,
    createdAt: moment().add(24, 'M'),
    firstName: 'Rob',
    lastName: 'martin',
    middleName: 'den',
    email: 'rob.martin@gmail.com',
    address: '3811 Shobe Lane',
    address2: 'Behind nirma university',
    state: 'Colorado',
    zip: '80202',
    phone: '9703904167',
    cellPhone: '079 22222222',
    notes: 'Rob interested in 2BHK',
    city: 'Denver',
    title: 'Lead 2',
    company: 'Delby Developers inc',
    saluation: Saluation[1]
  }
];
